// extracted by mini-css-extract-plugin
module.exports = {"filter-menu-item":"filter-menu-item___1fLG8","is-active":"is-active___1l14u"};